import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-input-checkbox",
  templateUrl: "./input-checkbox.component.html",
  styleUrl: "./input-checkbox.component.scss",
  // changeDetection:ChangeDetectionStrategy.OnPush
})
export class InputCheckboxComponent {
  @Input() invertValue: boolean; //use the inverted value if a boolean (basically use one formControl using a boolean between two checkbox components)
  @Input() label: string = "";
  @Input() control: FormControl;
  @Input() value: any;
  @Input() multiple: boolean = false; //can handle multiple values
  @Input() options: { text: string; value: any }[] = []; 
  @Output() checkedChange = new EventEmitter<any>();

  get isChecked(): boolean {
    const currentValue = this.control?.value;
    
    if (this.multiple) {
      const arrayValue = currentValue || [];
      return Array.isArray(arrayValue) ? arrayValue.includes(this.value) : false;
    } else if (this.value) {
      return currentValue === this.value;
    } else {
      const boolValue = !!currentValue;
      return this.invertValue ? !boolValue : boolValue;
    }
  }

  isOptionChecked(optionValue: any): boolean {
    const currentValue = this.control?.value || [];
    return Array.isArray(currentValue) ? currentValue.includes(optionValue) : false;
  }

  toggleCheck(value?: any) {
    if (this.multiple) {
      const currentValue = this.control?.value || [];
      let newValue: any[];
      
      if (Array.isArray(currentValue)) {
        if (currentValue.includes(value)) {
          newValue = currentValue.filter(v => v !== value);
        } else {
          newValue = [...currentValue, value];
        }
      } else {
        newValue = [value];
      }
      
      this.control.setValue(newValue);
    } else if (this.value) {
      this.control.setValue(this.isChecked ? null : this.value);
    } else {
      const currentValue = !!this.control?.value;
      const newValue = !currentValue;
      this.control.setValue(newValue);
    }
    
    this.checkedChange.emit();
  }
}
